// extracted by mini-css-extract-plugin
module.exports = {"cardImage":"s0Fl5CSNfJBSk1fYi3Q6J","cardDesc1":"_2YAqV9w2tzda2CTlIJcFdH","cardDesc2":"HoR5w2QsMnVBfsn4_1e0Y","cardDesc3":"_3909gFbvRYAD8Jwj4b5z4c"};